<bs-digital-linear-result-model-header
    [title]="title"
    [subtitle]="subTitle"
    [expand]="expanded"
    [odds]="succeededSlip.totalOdds"
    [isEpcotEnabled]="isEpcotEnabled"
    [boostedOdds]="succeededSlip.boostedOdds"
    [oddsDisplayFormat]="oddsDisplayFormat"
    [multiTitleBadge]="multiTitleBadge"
    (expandToggled)="toggleExpand($event)" />

<ng-container *ngIf="expanded">
    <bs-digital-result-succeeded-pick-list>
        <div class="linear-result-combo__pick-list" *ngFor="let pick of succeededSlip.picks; let last = last" [ngClass]="{ 'last-child': last }">
            <div class="linear-result-combo-pick-wrapper">
                <div class="linear-result-combo-pick-indicator">
                    <span class="theme-radio-off indicator-open"></span>
                </div>
                <bs-digital-result-succeeded-pick
                    [isLinear]="true"
                    [pick]="pick"
                    [oddsDisplayFormat]="oddsDisplayFormat"
                    [isSummaryVisible]="false"
                    [summary]="summaryViewModel"
                    [teaserPicks]="teaserPicksFromState" />
            </div>
        </div>
        <bs-digital-linear-result-bet-returns
            [stake]="succeededSlip.totalStake"
            [possibleWinningsNet]="summaryViewModel.possibleWinnings?.value"
            [possibleWinningsGross]="summaryViewModel.possibleWinningsGross"
            [rewardTokenInfo]="summaryViewModel.rewardTokenInfo"
            [boostedValue]="summaryViewModel.possibleWinnings?.boostedValue" />
    </bs-digital-result-succeeded-pick-list>

    <bs-digital-result-keep-placed
        *ngIf="resultState$ | async as resultState"
        [isLinear]="true"
        [keepPlaced]="keepPlaced(resultState)"
        [betType]="id"
        (keepPlacedChanged)="onKeepPlacedChanged($event)" />

    <bs-digital-linear-result-links [succeededSlips]="[succeededSlip]" [inColumn]="inColumn" />
</ng-container>
